/*
  11hektar 30 okt (Hampus: "det borde bli enklare att köpa det som föreslås"): quizresultatet.
  - Rutan "Din rutin" direkt under rubriken: Vårt val per steg (bild, namn, pris) + knappen "Lägg rutinen i varukorgen".
    Knappen och dess logik är quizets egen ([data-routine], flyttas bara hit), så Välj/Vald på korten styr fortfarande innehållet.
  - Varje steg visar två kort (Vårt val + ett alternativ, samt det kort som är Valt); resten bakom "Visa fler …".
  - Påverkar bara sidor med quizet (.ehq). Lyssnar på quizets händelse ehq:result. Töm filen för att återställa.
*/
(function(){
  var CSS = '' +
    '.ehq-sum{background:#f7f2e9;border-radius:12px;padding:16px;margin:16px 0 28px}' +
    '.ehq-sum__h{margin:0 0 10px;font-size:1.15em}' +
    '.ehq-sum__list{list-style:none;margin:0 0 14px;padding:0}' +
    '.ehq-sum__row{display:flex;align-items:center;gap:12px;padding:8px 0;border-top:1px solid rgba(0,0,0,.08)}' +
    '.ehq-sum__row:first-child{border-top:0}' +
    '.ehq-sum__img{flex:0 0 56px;width:56px;height:56px;border-radius:8px;overflow:hidden;background:#fff}' +
    '.ehq-sum__img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.ehq-sum__txt{flex:1;min-width:0}' +
    '.ehq-sum__step{display:block;font-size:.75em;letter-spacing:.08em;text-transform:uppercase;opacity:.65}' +
    '.ehq-sum__name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:inherit;text-decoration:none;font-size:.95em;line-height:1.3}' +
    '.ehq-sum__price{flex:0 0 auto;font-size:.95em;white-space:nowrap}' +
    '.ehq-sum__none{opacity:.65;font-size:.9em}' +
    '.ehq-sum [data-routine]{margin:0}' +
    '.ehq-sum [data-routine-add]{width:100%}' +
    '.ehq-sum__hint{margin:10px 0 0;font-size:.85em;opacity:.75}' +
    '.ehq-collapsed > .card__container:nth-child(n+3):not(.is-picked){display:none}' +
    '.ehq-alt{display:block;margin:12px auto 0;background:none;border:0;padding:8px 4px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;color:inherit;font:inherit}';

  function addCss(){ if(document.getElementById('ehq-plus-css')) return; var s=document.createElement('style'); s.id='ehq-plus-css'; s.textContent=CSS; document.head.appendChild(s); }
  function num(t){ var n=parseInt(String(t||'').replace(/[^0-9]/g,''),10); return isNaN(n)?0:n; }
  function esc(s){ return String(s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function update(res){
    var box=res.querySelector('.ehq-sum'); if(!box) return;
    var list=box.querySelector('.ehq-sum__list'); var rows=[]; var sum=0;
    res.querySelectorAll('[data-steps] .ehq__step').forEach(function(st){
      var grid=st.querySelector('[data-step-grid]'); if(!grid || grid.dataset.cart!=='1') return;
      var label=((st.querySelector('h3')||{}).textContent||'').trim();
      var c=grid.querySelector('.card__container.is-picked');
      if(!c){ rows.push('<li class="ehq-sum__row"><div class="ehq-sum__txt"><span class="ehq-sum__step">'+esc(label)+'</span><span class="ehq-sum__none">Inget valt</span></div></li>'); return; }
      var img=c.querySelector('img'), a=c.querySelector('.card__title a'), pr=c.querySelector('.card__price');
      var href=a?a.getAttribute('href'):'#';
      sum+=num(pr&&pr.textContent);
      rows.push('<li class="ehq-sum__row"><a class="ehq-sum__img" href="'+esc(href)+'">'+(img?'<img src="'+esc(img.getAttribute('src'))+'" alt="" loading="lazy">':'')+'</a><div class="ehq-sum__txt"><span class="ehq-sum__step">'+esc(label)+'</span><a class="ehq-sum__name" href="'+esc(href)+'">'+esc(a&&a.textContent)+'</a></div><span class="ehq-sum__price">'+esc(pr&&pr.textContent.trim())+'</span></li>');
    });
    list.innerHTML=rows.join('');
    box.style.display=rows.length?'':'none';
    var hint=box.querySelector('.ehq-sum__hint');
    if(hint){ hint.textContent = sum>=700 ? 'Fri frakt ingår.' : (sum>0 ? 'Fri frakt från 700 kr.' : ''); }
  }

  function enhance(){
    var root=document.querySelector('.ehq'); if(!root) return;
    var res=root.querySelector('[data-result]'); if(!res) return;
    var stepsWrap=res.querySelector('[data-steps]'), rc=res.querySelector('[data-routine]');
    if(!stepsWrap || !rc) return;
    addCss();
    var box=res.querySelector('.ehq-sum');
    if(!box){
      box=document.createElement('div'); box.className='ehq-sum';
      box.innerHTML='<h3 class="ehq-sum__h">Din rutin</h3><ul class="ehq-sum__list"></ul>';
      stepsWrap.parentNode.insertBefore(box, stepsWrap);
      box.appendChild(rc);
      var hint=document.createElement('p'); hint.className='ehq-sum__hint'; box.appendChild(hint);
      stepsWrap.addEventListener('click',function(e){ if(e.target.closest('[data-pick]')) setTimeout(function(){ update(res); },0); });
    }
    stepsWrap.querySelectorAll('.ehq__step').forEach(function(st){
      var grid=st.querySelector('[data-step-grid]'); if(!grid || st.querySelector('.ehq-alt')) return;
      var n=grid.querySelectorAll(':scope > .card__container').length;
      if(n<=2) return;
      grid.classList.add('ehq-collapsed');
      var label=((st.querySelector('h3')||{}).textContent||'').trim().toLowerCase();
      var more='Visa '+(n-2)+' till'+(label?' – '+label:'');
      var b=document.createElement('button'); b.type='button'; b.className='ehq-alt'; b.textContent=more; b.setAttribute('aria-expanded','false');
      b.addEventListener('click',function(){ var c=grid.classList.toggle('ehq-collapsed'); b.textContent=c?more:'Visa färre'; b.setAttribute('aria-expanded',c?'false':'true'); });
      st.appendChild(b);
    });
    update(res);
  }

  window.addEventListener('ehq:result', function(){ setTimeout(enhance, 0); });
})();
